module.exports = __webpack_public_path__ + "img/3.1.2.6a41ce62.png";